'use client';
import { useEffect } from 'react';
import { useSessionCache, refreshAppContext } from '@/lib/session/sessionCache';
import { UNREAD_REFRESH_EVENT } from './unreadEvents';

export { UNREAD_REFRESH_EVENT };

/** Ask the shared app context to refresh (after sending/reading messages). */
export function refreshUnreadMessages() {
  void refreshAppContext();
}

/** Unread count comes from the shared app context (refreshed every 60s while the tab is visible). */
export function useUnreadMessages(enabled: boolean = true, _deps: unknown = null): number {
  const snap = useSessionCache();
  useEffect(() => {
    // no per-hook fetching or polling; the app context owns it
  }, [enabled]);
  return enabled && snap.signedIn ? snap.unreadMessages : 0;
}
